import { faFolderOpen } from '@fortawesome/pro-regular-svg-icons';
import type { RowObject } from '@highcharts/dashboards/es-modules/Data/DataTable.js';
import { idColumn, multiValueColumn, rowActionsColumn } from '@h20-shared/grids/columns';
import type { RowActionLink } from '@h20-shared/grids/columns';
import { defineGridColumns } from './column-definition';
import type { DashboardColumnSettings, QueryColumnKey } from './column-definition';

function multiValueColumnFrom(
    columnKeys: readonly QueryColumnKey<'formMissingness'>[]
): DashboardColumnSettings {
    return multiValueColumn<RowObject>({
        getNumbers: (row) => {
            const cells = columnKeys.map((columnKey) => row[columnKey]);
            return cells.every((cell) => typeof cell === 'number') ? cells : null;
        },
    });
}

function patientOverviewLink(row: RowObject): RowActionLink | null {
    const patientId = row['patientId' satisfies QueryColumnKey<'formMissingness'>];
    return typeof patientId === 'string' ? ['/patients', patientId, 'view'] : null;
}

export const FORM_MISSINGNESS_COLUMNS = defineGridColumns('formMissingness', [
    [
        'patientId',
        idColumn<RowObject>({
            copyConfig: {
                copyButtonAccessibleLabel: 'Dashboard.Query.FormMissingness.CopyPatientId',
                toastOnCopy: {
                    heading: 'Dashboard.Query.FormMissingness.PatientIdCopied',
                    body: 'Dashboard.Query.FormMissingness.PatientIdCopiedBody',
                },
            },
            getLink: patientOverviewLink,
        }),
    ],
    ['missingQuestions', multiValueColumnFrom(['missingQuestions', 'totalQuestions'])],
    ['totalQuestions', { hide: true }],
    ['openQueries', multiValueColumnFrom(['openQueries', 'totalQueries'])],
    ['totalQueries', { hide: true }],
    [
        'patientId',
        {
            ...rowActionsColumn<RowObject>([
                {
                    icon: faFolderOpen,
                    label: 'Dashboard.Query.FormMissingness.OpenPatientOverview',
                    getLink: patientOverviewLink,
                },
            ]),
            headerName: 'Dashboard.Grid.Actions',
        },
    ],
]);
